import React from 'react';
import { Link } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { toUTCDateString } from '../../utils/dates';
import styles from './DisplayOrganization.module.css';
import RemoveOrgUser from '../../components/RemoveOrgUser';
import { UserConsumer } from '../../contexts/UserContext';

class OrganizationUsersTable extends React.Component {
  state = {
    orgUserDeleted: false,
    modalErrors: {
      server_message: null,
    },
    modalOpen: false,
  };

  getColumnSettings = (roleNames) => {
    const columnSettings = [
      {
        name: 'ID',
        options: {
          filter: false,
          customBodyRender: (id) => (
            <Link to={`/lookup/user_id/${id}`}>{id}</Link>
          ),
        },
      },
      { name: 'Name', options: { filter: false } },
      { name: 'Email', options: { filter: false } },
      'Access Level',
      {
        name: 'Created On',
        options: {
          customBodyRender: (date) => toUTCDateString(date),
          filter: false,
        },
      },
      {
        name: 'Last Login',
        options: {
          customBodyRender: (date) =>
            date ? toUTCDateString(new Date(date * 1000)) : '',
          filter: false,
        },
      },
      {
        name: 'Latest Feed Event',
        options: {
          customBodyRender: (data) => {
            if (data) {
              const toolTipText = `Module: ${data.module}, Action: ${data.action}`;
              return (
                <span>
                  {toUTCDateString(new Date(data.created * 1000))}
                  <Tooltip title={toolTipText}>
                    <InfoIcon className={styles.infoIcon} />
                  </Tooltip>
                </span>
              );
            } else {
              return '';
            }
          },
          filter: false,
        },
      },
    ];

    // Only certain user roles should be able to see the 'delete' button
    const hasRemovePermission =
      roleNames.includes('admin') ||
      roleNames.includes('insights_user_manager');
    hasRemovePermission &&
      columnSettings.push({
        name: 'Remove from Organization',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (ou) => {
            return (
              <div className={styles.removeButtonCell}>
                <RemoveOrgUser
                  user={ou.user}
                  organization={ou.organization}
                  onSuccess={this.props.onSuccess}
                />
              </div>
            );
          },
        },
      });

    return columnSettings;
  };

  getTableSettings = () => ({
    filterType: 'dropdown',
    responsive: 'standard',
    selectableRows: 'none',
    pagination: false,
    print: false,
    download: false,
    viewColumns: false,
    customSort: (data, colIndex, order) => {
      return data.sort((a, b) => {
        let aData = a.data[colIndex];
        let bData = b.data[colIndex];
        if (aData && aData.created) {
          aData = aData.created;
        }
        if (bData && bData.created) {
          bData = bData.created;
        }
        return (aData < bData ? -1 : 1) * (order === 'desc' ? 1 : -1);
      });
    },
  });

  render() {
    let users = this.props.users;
    const data = users.map((ou) => {
      return [
        ou.user.id,
        ou.user.name,
        ou.user.email,
        ou.access,
        ou.user.created,
        ou.user.last_successful_login,
        ou.user.latest_feed_event,
        ou,
      ];
    });

    return (
      <div className={styles.usersTableContainer}>
        <UserConsumer>
          {(user) => (
            <React.Fragment>
              <MUIDataTable
                data={data}
                columns={this.getColumnSettings(user.roleNames)}
                options={this.getTableSettings()}
              />
            </React.Fragment>
          )}
        </UserConsumer>
      </div>
    );
  }
}

export default OrganizationUsersTable;
